import { render, staticRenderFns } from "./ModalDettagliCsv.vue?vue&type=template&id=0b1e85e0"
import script from "./ModalDettagliCsv.vue?vue&type=script&lang=js"
export * from "./ModalDettagliCsv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports